module.exports = __webpack_public_path__ + "static/cashcabin-casino-2af116a3367cb8b651de8c18e9c0a5fc.png";